/* eslint-disable camelcase */
const SOURCE_TYPE = 'SOURCE'

const getSourceConstraints = (sourceConstraints, constraint) => {
  const { type, preferred_sources } = constraint

  if (type === SOURCE_TYPE && preferred_sources) {
    const { soft_preference, anchors } = preferred_sources

    if (anchors && anchors.length) {
      sourceConstraints.push({
        sources: anchors.map(({ name, sub_type: subType }) => ({ name, subType })),
        softPreference: soft_preference
      })
    }
  }
  return sourceConstraints
}

/* eslint-disable camelcase */
const formatSourceConstraints = constraints => (Array.isArray(constraints) && constraints.length
  ? constraints.reduce(getSourceConstraints, [])
  : null)

export const formatPolicy = ({ wanted }) => wanted.map(({ name, constraints }) => ({ name, sourceConstraints: formatSourceConstraints(constraints) }))

export const getRequiredAttributes = policyAttributes => policyAttributes.map(({ name }) => name)

export const getRequiredSources = (policyAttributes) => {
  const preferredSources = []

  policyAttributes.forEach(({ sourceConstraints }) => {
    sourceConstraints && sourceConstraints.forEach(({ softPreference, sources }) => {
      if (!softPreference) {
        sources.forEach(({ name, subType }) => {
          const sourceAdded = !!preferredSources.find(({ name: sourceName }) => sourceName === name)
          if (name && !sourceAdded) {
            preferredSources.push({
              name,
              subType: subType || ''
            })
          }
        })
      }
    })
  })

  return preferredSources
}
